import _ from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import { useCustomReducer } from '../../../../../base/customHooks'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import IPSelectBox from '../../../../../components/IPSelectBox'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import { getCompanyApi } from '../../../components/api'
import { ICompany } from '../../../components/models/models'
import { IBankModelList } from '../models/models'
import { GetBanksApi } from '../services/getBanksApi'
import Table from '../../../../../components/Table'

interface IListInstallmentState {
  company?: ISelectOption
  pos?: ISelectOption
  type?: ISelectOption | null
}

function BankList(props: BaseComponentWithContextProps) {
  const getInitialState = (): IListInstallmentState => {
    return {
    }
  }
  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IListInstallmentState>(intialState)
  const [companies, setCompanies] = useState<ISelectOption[]>([])
  const [bank, setBank] = useState<IBankModelList[]>([])
  const [filterBank, setFilterBank] = useState<IBankModelList[]>([])
  const [posFilterOptions, setPosFilterOptions] = useState<ISelectOption[]>([])

  useEffect(() => {
    getCompanies()
    getBanks()
  }, [])

  const getCompanies = async () => {
    const company: ICompany[] = await getCompanyApi()
    const data: ISelectOption[] = []
    company
      .filter(c => {
        return c.Name !== 'Index Grup'
      })
      .map(com => {
        if (com.Name === 'Index') data.push({ value: '1000', label: com.Name })
        if (com.Name === 'Datagate') data.push({ value: '1100', label: com.Name })
        if (com.Name === 'Despec') data.push({ value: '1200', label: com.Name })
        if (com.Name === 'Netex') data.push({ value: '2300', label: com.Name })
      })
    setCompanies(data.sort((a, b) => Number(a.value) - Number(b.value)))
  }

  const getBanks = async () => {
    props.showLoading()
    const bankApi: GetBanksApi = new GetBanksApi({})
    bankApi.listAllBanks().then((res: any) => {
      if (res) {
        setBank(res)
        setFilterBank(res)
        props.hideLoading()
      }
    })
      .catch((e: any) => {
        Swal.fire({
          icon: 'error',
          title: e.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  // Flags değeri ödeme adımındaki POS yönlendirmesiyle aynıdır (PaymentService "PSP dispatch").
  // POS adı banka adı/POS koduyla eşleştirilerek bulunamaz (ör. AkÖde satırının POS kodu AKM0),
  // bu yüzden sabit eşleme kullanılır.
  const flagLabels: Record<number, string> = {
    1: 'Normal POS',
    2: 'ParamPos',
    3: 'AkÖde',
    4: 'Paratika',
  }

  const buildPosFilters = (banks: IBankModelList[]) => {
    const options = _.uniq(banks.map(b => Number(b.Flags)))
      .sort((a, b) => a - b)
      .map(flag => ({ value: flag, label: flagLabels[flag] || `Flags ${flag}` }))

    setPosFilterOptions(options)
  }

  useEffect(() => {
    if (bank.length > 0) {
      buildPosFilters(bank)
    }
  }, [bank])

  const tableColumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'index',
      },
      {
        Header: 'Şirket',
        accessor: 'company',
      },
      {
        Header: 'Banka',
        accessor: 'banks',
      },
      {
        Header: 'Durum',
        accessor: 'active',
      },
      {
        Header: 'Flags',
        accessor: 'flags',
      },
      {
        Header: 'BankID',
        accessor: 'bankID',
      },
      {
        Header: 'PosType',
        accessor: 'posType',
      },
      {
        Header: 'PosCode',
        accessor: 'posCode',
      },
    ],
    []
  )

  const tableData = useMemo(() =>
    filterBank.map((element, index) => {
      const posName = posFilterOptions.find(p => Number(p.value) === Number(element.Flags))?.label
      const data = {
        index: index + 1,
        company: companies.find(a => element.Company === a.value)?.label,
        banks: element.TheName,
        active: element.Active === 1 ? "Aktif" : "Pasif",
        flags: `${element.Flags}${posName ? ` (${posName})` : ''}`,
        bankID: element.BankId,
        posType: element.Vpostype,
        posCode: element.Poscode
      }
      return data
    })
    , [filterBank, companies, posFilterOptions])

  useEffect(() => {
    let filtered = bank
    if (state.company) {
      filtered = filtered.filter(a => a.Company === state.company?.value)
    }
    if (state.pos) {
      filtered = filtered.filter(a => Number(a.Flags) === Number(state.pos?.value))
    }
    setFilterBank(filtered)
  }, [state.company, state.pos, bank])

  return (
    <div className='container'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <div className='col-12 col-md-9 mb-2'>
              <span className='h4'>Banka Listesi</span>
            </div>
          </div>
          <div className='card-body'>
            <div className='form-row'>
              <div className='form-group col-md-3'>
                <label className='labeltext'>Şirket</label>
                <IPSelectBox
                  isClearable
                  options={companies}
                  value={state.company}
                  onChangeSingle={option => {
                    setState({ company: option })
                  }}
                />
              </div>
              <div className='form-group col-md-3'>
                <label className='labeltext'>POS</label>
                <IPSelectBox
                  isClearable
                  options={posFilterOptions}
                  value={state.pos}
                  onChangeSingle={option => {
                    setState({ pos: option })
                  }}
                />
              </div>
            </div>
            <div className='form-row'>
              <Table columns={tableColumns} data={tableData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default componentWithContext(BankList)

